import { Box, ButtonBase } from "@mui/material";
import { cloudflareCDN } from "ui";

interface StartingCardRemixProps {
  img: string;
  title: string;
  onClick: () => void;
}

/**
 * Remix-mode variant of the "starting option" card. The remix artwork already
 * includes its title and arrow affordance, so the card is just the full-bleed
 * image clipped to a rounded, shadowed card. Shown on /starting-options only when
 * the user is in remix mode (useRemixMode); otherwise StartingCard is used.
 */
export const StartingCardRemix = ({
  img,
  title,
  onClick,
}: StartingCardRemixProps) => (
  <ButtonBase
    onClick={onClick}
    sx={{
      flex: 1,
      width: "100%",
      display: "block",
      backgroundColor: "#fff",
      borderRadius: 5,
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
      transition: "transform .15s, box-shadow .15s",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 18px 44px rgba(0,0,0,0.18)",
      },
    }}
  >
    <Box
      component="img"
      src={cloudflareCDN(
        window.location.origin + img,
        "width=1200,fit=scale-down,format=auto",
      )}
      alt={title}
      sx={{ width: "100%", height: "auto", display: "block" }}
    />
  </ButtonBase>
);
